// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/wand.js';

import { paths } from '../generated/wand';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('wand', Original, paths);
